<template>
  <div class="api-info">
    <h1>API接口说明</h1>
    <h2>请求方式</h2>
    <h3>请求方式： POST</h3>
    <h2>基础参数</h2>
    <h3>输入Headers</h3>
    <table>
      <tr style="background-color: #f0f0f0;font-weight: bold">
        <td>参数名称</td>
        <td>参数值</td>
        <td>是否必填</td>
        <td>备注</td>
      </tr>
      <tr>
        <td>Content-Type</td>
        <td>multipart/form-data</td>
        <td>是</td>
        <td></td>
      </tr>
      <tr>
        <td>X-Access-Token</td>
        <td>
          eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6IjEyMzQ1IiwiZXhwIjoxNjk4MjkwNTAxfQ.killp_L3PaJaWM74xk7NYf5WWjfA1HNKxm7Dp3zGqtQ
        </td>
        <td>是</td>
        <td>联系技术获取账号等参数后，使用登陆API获取</td>
      </tr>
    </table>
    <h2>接口名称</h2>
    <h3>违约披露信息上传</h3>
    <span style="margin-left: 40px;">描述：上传违约信息</span>
    <h3>请求url</h3>
    <span style="margin-left: 40px;">http://lvyuexinyong.com/cmp-boot/announce/upload</span>
    <h3>请求参数</h3>
    <table>
      <tr style="background-color: #f0f0f0;font-weight: bold">
        <td width="130px">参数名称</td>
        <td width="80">类型</td>
        <td width="90">是否必须</td>
        <td width="280">示列</td>
        <td width="220">备注</td>
      </tr>
      <tr>
        <td>contractName</td>
        <td>String</td>
        <td>是</td>
        <td>北京市共有产权住房现房买卖合同</td>
        <td>合同名称</td>
      </tr>
      <tr>
        <td>contractType</td>
        <td>int</td>
        <td>是</td>
        <td>1</td>
        <td>合同类型（1：买卖合同，
          2：供用电、水、气、热力合同，
          3：赠与合同，
          4：借款合同，
          5：租赁合同，
          6：融资租赁合同，
          7：承揽合同，
          8：建设工程合同，
          9：运输合同，
          10：技术合同，
          11：保管合同，
          12：仓储合同，
          13：委托合同，
          14：行纪合同，
          15：居间合同）</td>
      </tr>
      <tr>
        <td>startTime</td>
        <td>String</td>
        <td>是</td>
        <td>2022-01-01</td>
        <td>签订日期</td>
      </tr>
      <tr>
        <td>endTime</td>
        <td>String</td>
        <td>是</td>
        <td>2023-01-01</td>
        <td>终止日期</td>
      </tr>
      <tr>
        <td>contractMoney</td>
        <td>String</td>
        <td>是</td>
        <td>5000.00</td>
        <td>合同金额</td>
      </tr>
      <tr>
        <td>wyTime</td>
        <td>String</td>
        <td>是</td>
        <td>2023-01-01</td>
        <td>违约日期</td>
      </tr>
      <tr>
        <td>reason</td>
        <td>String</td>
        <td>是</td>
        <td>逾期交付</td>
        <td>违约条款</td>
      </tr>
      <tr>
        <td>files</td>
        <td>file</td>
        <td>否</td>
        <td>(binary)</td>
        <td>上传证据</td>
      </tr>
      <tr>
        <td>childFormList</td>
        <td>String</td>
        <td>是</td>
        <td>
          [{"type":"1","oname":"张立","uccode":"42062518921515","address":"湖北省武汉市","contactName":"张开","telephone":"18886456214","email":"82842@163.com"}]
        </td>
        <td>主体信息（JSON字符串，支持多个主体信息上传）</td>
      </tr>
    </table>
    <h3>childFormList字段信息</h3>
    <table>
      <tr style="background-color: #f0f0f0;font-weight: bold">
        <td width="130px">参数名称</td>
        <td width="80">类型</td>
        <td width="90">是否必须</td>
        <td width="280">示列</td>
        <td width="220">备注</td>
      </tr>
      <tr>
        <td>type</td>
        <td>int</td>
        <td>是</td>
        <td>1</td>
        <td>主体类型（1：企业或其他组织，2：自然人）</td>
      </tr>
      <tr>
        <td>oname</td>
        <td>String</td>
        <td>是</td>
        <td>张立</td>
        <td>法定全称/姓名</td>
      </tr>
      <tr>
        <td>uccode</td>
        <td>String</td>
        <td>是</td>
        <td>42062518921515</td>
        <td>统一社会信用代码/身份证号码</td>
      </tr>
      <tr>
        <td>address</td>
        <td>String</td>
        <td>是</td>
        <td>湖北省武汉市</td>
        <td>联系地址</td>
      </tr>
      <tr>
        <td>contactName</td>
        <td>String</td>
        <td>是</td>
        <td>张利</td>
        <td>联系人姓名</td>
      </tr>
      <tr>
        <td>telephone</td>
        <td>String</td>
        <td>是</td>
        <td>18886456214</td>
        <td>联系电话</td>
      </tr>
      <tr>
        <td>email</td>
        <td>String</td>
        <td>是</td>
        <td>82842@163.com</td>
        <td>电子邮箱</td>
      </tr>
    </table>
    <h3>请求成功返回结果</h3>
    <pre class="pre-info">
        {
          "success": "true",
          "code": 200,
          "message": "成功",
          "data": "",
          "timestamp": "1697696313075",
        }
    </pre>
    <h3>请求失败返回结果</h3>
    <pre class="pre-info">
        {
          "success": "false",
          "code": 500,
          "message": "失败",
          "data": "",
          "timestamp": "1697696313075",
        }
    </pre>
  </div>
</template>

<script>
export default {
  name: "Api"
}
</script>

<style scoped>
.api-info {
  width: 1200px;
  margin: 20px auto;
  background: #FFFFFF;
  padding: 50px 100px;
}

.api-info h {
  margin: 20px;
}

.api-info table {
  width: 100%;
  border: #ccc solid 1px;
}

.api-info table td {
  border: 1px solid #ccc;
  text-align: left;
  line-height: 2;
  padding: 6px 13px;
  word-break: break-all;
}

.pre-info {
  white-space: pre-wrap;
  margin-bottom: 5px;
  margin-top: 5px;
  padding: 5px 10px;
  border: #ccc solid 1px;
  border-radius: 3px;
  background-color: #f0f0f0;
}
</style>
